module.exports = (s) => {
  return [
    {
      name: '转化名称',
      value: 'conversion_name',
      align: 'center',
      width: '250px',
      overflow: false,
    },
    {
      name: '转化id',
      value: 'conversion_id',
      align: 'center',
      overflow: false,
    },
    {
      name: '应用',
      value: 'promoted_object_name',
      overflow: false,
      align: 'center',
    },
    {
      name: '状态',
      value: 'access_status',
      align: 'center',
      format: (row, cell, cellValue) => {
        const type = {
          'ACCESS_STATUS_COMPLETED': '已接入',
          'ACCESS_STATUS_PENDING': '待接入',
        };
        return type[cellValue];
      },
    },
    {
      name: '上报方式',
      value: 'access_type',
      align: 'center',
      format: (row, cell, cellValue) => {
        const type = {
          'ACCESS_TYPE_SDK': 'SDK',
          'ACCESS_TYPE_API': 'API',
        };
        return type[cellValue];
      },
    },
    {
      name: '优化目标',
      align: 'center',
      value: 'optimization_goal',
      format: (row, cell, cellValue) => {
        return s.retranslation.conversion[cellValue];
      },
    },
    {
      name: '深度优化目标(行为)',
      value: 'deep_behavior_optimization_goal',
      align: 'center',
      format: (row, cell, cellValue) => {
        return s.retranslation.conversion[cellValue] || '-';
      },
    },
    {
      name: '深度优化目标(ROI)',
      value: 'deep_worth_optimization_goal',
      align: 'center',
      format: (row, cell, cellValue) => {
        const type = {
          'GOAL_7DAY_PURCHASE_ROAS': '七日付费 ROI',
          'GOAL_30DAY_ORDER_ROAS': '下单 ROI',
          'GOAL_1DAY_PURCHASE_ROAS': '首日付费ROI',
          'GOAL_1DAY_MONETIZATION_ROAS': '首日变现 ROI',
          'GOAL_7DAY_MONETIZATION_ROAS': '七日变现 ROI',
        };
        return cellValue ? type[cellValue] : '-';
      },
    },
    {
      name: '监控链接',
      value: 'feedback_url',
      align: 'center',
      format: (row, cell, cellValue) => {
        return cellValue || '-';
      },
    },
  ];
};
